import {Component, tag} from 'doz'
import ellipsis from 'text-ellipsis'

@tag('program')
export default class extends Component {
    props = {
        mviewId: '',
        title: '',
        description: '',
        short_description: '',
        image: '',
        hourStart: '',
        hourEnd: '',
        isToday: false,
        isOnAir: false
    };

    lightenHexColor(hex, percent) {
        // Rimuove il carattere '#' se presente
        hex = hex.replace(/^#/, '');

        // Converti i valori esadecimali in decimali
        let num = parseInt(hex, 16);

        let r = (num >> 16) + Math.round(2.55 * percent);
        let g = ((num >> 8) & 0x00FF) + Math.round(2.55 * percent);
        let b = (num & 0x0000FF) + Math.round(2.55 * percent);

        // Assicura che i valori r, g, b siano nel range [0, 255]
        r = r < 255 ? (r < 0 ? 0 : r) : 255;
        g = g < 255 ? (g < 0 ? 0 : g) : 255;
        b = b < 255 ? (b < 0 ? 0 : b) : 255;

        // Converti i valori r, g, b nuovamente in esadecimale e restituisci il colore
        return `#${(0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
    }

    parseTime(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number);
        return { hours, minutes };
    }

    timeDifferenceInMinutes(time1, time2) {
        const time1Parsed = this.parseTime(time1);
        const time2Parsed = this.parseTime(time2);

        const time1Minutes = time1Parsed.hours * 60 + time1Parsed.minutes;
        const time2Minutes = time2Parsed.hours * 60 + time2Parsed.minutes;

        return Math.abs(time1Minutes - time2Minutes);
    }

    propsConvert = {
        description: v => ellipsis(v, 50),
        isOnAir: v => {
            if (this.props.isToday) {

                let dateHourStart = new Date();
                let hourStartParts = this.props.hourStart.split(':');
                let hourStartPartsHour = parseInt(hourStartParts[0]);
                let hourStartPartsMinute = parseInt(hourStartParts[1]);
                dateHourStart.setHours(hourStartPartsHour, hourStartPartsMinute);

                let dateHourEnd = new Date();
                let hourEndParts = this.props.hourEnd.split(':');
                let hourEndPartsHour = parseInt(hourEndParts[0]);
                let hourEndPartsMinute = parseInt(hourEndParts[1]);
                dateHourEnd.setHours(hourEndPartsHour, hourEndPartsMinute);

                let dateNow = this.convertUTCDateToLocalDate(new Date());
                dateHourStart = this.convertUTCDateToLocalDate(dateHourStart);
                dateHourEnd = this.convertUTCDateToLocalDate(dateHourEnd);

                v = dateNow >= dateHourStart && dateNow <= dateHourEnd;

            }
            return v;
        }
    };

    template(h) {

        //console.log('isOnAir', this.props.isOnAir, this.props.title, this.props.hourStart, this.props.hourEnd)

        let onAirBackgroundColor;

        if (this.PLAYER_CONFIG.programOnAirBackgroundColor)
            onAirBackgroundColor = this.PLAYER_CONFIG.programOnAirBackgroundColor;
        else if (this.PLAYER_CONFIG.programsBackgroundColor)
            onAirBackgroundColor = this.lightenHexColor(this.PLAYER_CONFIG.programsBackgroundColor, 20); // Adjust the percentage to lighten
        else
            onAirBackgroundColor = 'transparent';

        let isSubSchedule = false;

        if (this.props.mviewId === 544 || this.props.mviewId === 545) { // solo per UniBG
            if (this.timeDifferenceInMinutes(this.props.hourStart, this.props.hourEnd) <= 60) {
                isSubSchedule = true;
            }
        }

        //let inNorba = this.props.mviewId === 2 || this.props.mviewId === 12;
        let title = this.props.title;
        let subtitle = this.props.subtitle || this.props.short_description || '';
        if (title === subtitle) subtitle = '';

        return h`
            <style>
                .container {
                    padding: 8px;
                    display: flex;
                    font-size: 12px;
                    align-items: center;
                    border-bottom: 1px solid ${this.PLAYER_CONFIG.programsProgramSeparatorColor || this.THEME.onPrimaryColorAlpha};
                    color: ${this.THEME.onPrimaryColor};
                    background: transparent;
                    margin-left: ${isSubSchedule ? '40px' : 0};
                }
                
                .img {
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    object-position: top;
                    margin-right: 8px;
                    border-radius: 8px;
                    border: 2px solid ${this.PLAYER_CONFIG.programsProgramImageBorderColor || this.THEME.onPrimaryColorAlpha};
                    background: ${this.PLAYER_CONFIG.programsProgramImageBackgroundColor ? this.PLAYER_CONFIG.programsProgramImageBackgroundColor : 'transparent'};
                }
                
                .column-center {
                    width: 100px;
                }
                
                .title {
                    font-size: 14px;
                    color: ${this.PLAYER_CONFIG.programsProgramTitleColor || this.THEME.onPrimaryColor};
                    padding: 0;
                    margin: 0;
                    font-weight: bold;
                }
                
                .subtitle {
                    font-size: 14px;
                    color: ${this.PLAYER_CONFIG.programsProgramTitleColor || this.THEME.onPrimaryColor};
                    padding: 0;
                    margin: 4px 0 0 0;
                    font-weight: lighter;
                }
                
                .hours {
                    font-size: 12px;
                    opacity: 0.7;
                    margin: 4px 0 0 0;
                    color: ${this.PLAYER_CONFIG.programsProgramHoursColor || this.THEME.onPrimaryColor};
                }
                
                .on-air {
                    background: red;
                    color: white;
                    font-weight: bold;
                    text-transform: uppercase;
                    width: fit-content;
                    padding: 4px;
                    margin: 0 0 2px 0;
                    border-radius: 4px;
                }
                
                .on-air-background {
                    background: ${onAirBackgroundColor};
                }
               
            </style>
            <div class="container animated fadeIn ${this.props.isOnAir ? 'on-air-background' : ''}">
                <div d-show="${!!this.props.image}" class="column-left">
                    <img loading="lazy" class="img" src="${this.props.image}">
                </div>
                <div class="column-right">
                    <div d-ref="onAirLabel" d-show="${!!this.props.isOnAir}" class="on-air on-air-${!!this.props.isOnAir}">Ora in onda</div>
                    <h2 class="title">${title}</h2>
                    <h2 class="subtitle">${subtitle}</h2>
                    <div class="hours">${this.props.hourStart} ${isSubSchedule ? '' : (' - ' + this.props.hourEnd)}</div>
                </div>
            </div>
        `
    }

    onMountAsync() {
        if (this.props.isOnAir) {
            setTimeout(() => {
                this.scrollParentToChild(
                    this.getHTMLElement().parentElement.parentElement.parentElement,
                    this.getHTMLElement()
                );
            }, 2000);
        }
    }

}
